import { Action } from "@ngrx/store";
import { Dictionary } from "../models/common_types";

export const SET_LEFT_PANEL_DATA = "SET_LEFT_PANEL_DATA";
export const GET_LEFT_PANEL_DATA = "GET_LEFT_PANEL_DATA";
export const SET_DISPLAY = "HIDE_LEFT_PANEL";
export const SET_COLLAPSED = "SET_COLLAPSED";
export const SET_DISABLED = "SET_DISABLED";
export const ADD_WATCHLIST_DATA = "ADD_WATCHLIST_DATA";
export const DELETE_WATCHLIST_DATA = "DELETE_WATCHLIST_DATA";
export const SET_SELECTED_WATCHLIST = "SET_SELECTED_WATCHLIST";
export const UPDATE_WATCHLIST_DATA = "UPDATE_WATCHLIST_DATA";
export const UPDATE_CHARTS_DATA = "UPDATE_CHARTS_DATA";
export const UPDATE_COMPS_DATA = "UPDATE_COMPS_DATA";
export const UPDATE_COMPARATIVE_ANALYSIS_DATA =
  "UPDATE_COMPARATIVE_ANALYSIS_DATA";
export const SET_INIDIVIDUAL_FLAG = "SET_INIDIVIDUAL_FLAG";

export class GetLeftPanelData implements Action {
  readonly type = GET_LEFT_PANEL_DATA;
  constructor(public payload: Dictionary<any>) {}
}

export class SetLeftPanelData implements Action {
  readonly type = SET_LEFT_PANEL_DATA;
  constructor(public payload: Dictionary<any>) {}
}

export class SetDisplay implements Action {
  readonly type = SET_DISPLAY;
  constructor(public payload: boolean) {}
}

export class SetCollapsed implements Action {
  readonly type = SET_COLLAPSED;
  constructor(public payload: boolean) {}
}

export class SetDisabled implements Action {
  readonly type = SET_DISABLED;
  constructor(public payload: boolean) {}
}

export class AddWatchlistData implements Action {
  readonly type = ADD_WATCHLIST_DATA;
  constructor(public payload: Dictionary<any>) {}
}

export class DeleteWatchlistData implements Action {
  readonly type = DELETE_WATCHLIST_DATA;
  constructor(public payload: Dictionary<any>) {}
}

export class SetSelectedWatchlist implements Action {
  readonly type = SET_SELECTED_WATCHLIST;
  constructor(public payload: Dictionary<any>) {}
}

export class UpdateWatchlistData implements Action {
  readonly type = UPDATE_WATCHLIST_DATA;
  constructor(public payload: Dictionary<any>) {}
}

export class UpdateChartsData implements Action {
  readonly type = UPDATE_CHARTS_DATA;
  constructor(public payload: Dictionary<any>) {}
}

export class UpdateCompsData implements Action {
  readonly type = UPDATE_COMPS_DATA;
  constructor(public payload: Dictionary<any>) {}
}

export class UpdateComparativeAnalysisData implements Action {
  readonly type = UPDATE_COMPARATIVE_ANALYSIS_DATA;
  constructor(public payload: Dictionary<any>) {}
}

export class SetIndividualFlag implements Action {
  readonly type = SET_INIDIVIDUAL_FLAG;
  constructor(public payload: Dictionary<any>) {}
}

export type Actions =
  | SetLeftPanelData
  | GetLeftPanelData
  | SetDisplay
  | SetCollapsed
  | SetDisabled
  | AddWatchlistData
  | DeleteWatchlistData
  | SetSelectedWatchlist
  | UpdateWatchlistData
  | UpdateChartsData
  | UpdateCompsData
  | SetIndividualFlag
  | UpdateComparativeAnalysisData;
